'use strict';

import slick from 'slick-carousel';

export const carousel = (() => {

    /**
     * init
     */
    const init = () => {
        $('.js-carousel-hero').slick({
			arrows: false,
			speed: 0,
            autoplay: true,
            autoplaySpeed: 5800,
            variableWidth: true,
			swipe: false
        });

        $('.js-carousel-hero').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
            $('.js-belt span').removeClass('is-active');
            $('.js-belt').each(function() {
                $(this).find('span').eq(nextSlide).addClass('is-active');
            });
        });
    }

    // public
    return {
        init: init
    };
})();